export const getStatus = (str) => str.replace(/([A-Z])/g, ' $1').replace(/^./, (match) => match.toUpperCase());;
